//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
let d=[[],[[["calloutType","numContents"],"GetContents",{R_:{contents:""}},1,0],[["calloutType","contents"],"SetContents",{},2,0],[[],"GetOrientationType",{R_:{orientation:''}},0,0],[["orientation"],"SetOrientationType",{},1,0],[[],"GetCalloutOffsetDistance",{R_:{calloutOffset:''}},0,0],[["calloutOffset"],"SetCalloutOffsetDistance",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.ViewStyleFPCalloutConfigBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewStyleFPCalloutConfigBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewStyleFPCalloutConfigBuilder.OrientationType = Object.freeze({
    "Leadered" : "Leadered", "Aligned" : "Aligned"});

export default SPLM;